import { render } from "./RegisterIndividual.vue?vue&type=template&id=14b20cbf&ts=true"
import script from "./RegisterIndividual.vue?vue&type=script&lang=ts"
export * from "./RegisterIndividual.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__